<template>
  <div>
    <!-- 添加首页轮播图对话框 -->
    <el-dialog
        title="添加首页轮播图"
        :visible.sync="addDialogVisible"
        width="60%"
        append-to-body
        @close="addDialogClosed"
    >
      <el-form
          ref="addFormRef"
          :model="addForm"
          :rules="rules"
          label-width="140px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入名称"/>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="banner类型" prop="enumType">
              <el-select v-model="addForm.enumType" clearable placeholder="请选择banner类型" style="width: 100%">
                <el-option key="INDEX" label="首页轮播图" value="INDEX"></el-option>
                <el-option key="RACES" label="比赛" value="RACES"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="addForm.sort" placeholder="请输入排序" oninput="value=value.replace(/[^\d]/g,'')"/>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="是否启用" prop="enumEnable">
              <el-select v-model="addForm.enumEnable" clearable placeholder="请选择是否启用" style="width: 100%">
                <el-option key="NORMAL" label="是" value="NORMAL"></el-option>
                <el-option key="DISABLE" label="否" value="DISABLE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="跳转类型">
              <el-select v-model="skipType" clearable placeholder="请选择跳转类型" style="width: 100%">
                <el-option key="content" label="文章内容" value="content"></el-option>
                <el-option key="path" label="链接地址" value="path"></el-option>
                <el-option key="news" label="已有文章" value="news"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="skipType === 'path'">
            <el-form-item label="跳转链接" prop="path">
              <el-input v-model="addForm.path" placeholder="请输入跳转链接"/>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="skipType === 'news'">
            <el-form-item label="选择文章">
              <el-select v-model="addForm.content" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in articlesList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="24">
            <el-form-item label="上传图片" prop="md5">
              <thumbnail :is-crop='false' v-model="addForm.md5"></thumbnail>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="skipType === 'content'">
            <editor ref="getEditor" v-model="addForm.content" :type="'html'"></editor>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button @click="addBanner">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addBanner} from "@/api/banner/banner";
import {getData} from "@/utils/code";
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import Editor from '@/components/common/editor/editor'
import { getArticlesTitle } from '@/api/article/article'
import { bannerRules } from '@/js/rules'

export default {
  name: "addBanner",
  components: { Editor, Thumbnail },
  data() {
    return {
      avatar: "",
      show: false,
      size:2.1,
      bannerStatus: '',

      addForm: {
        skipType: '',
        content: '',
        path: '',
      }, //添加组织表单
      skipType: '',
      addDialogVisible: false,
      // 规则
      rules: bannerRules,
      articlesList: [],
      queryInfo: {
        keyword: ''
      }
    }
  },
  watch: {
    skipType(newVal,oldVal) {
      if (newVal !== oldVal) {
        this.addForm.content = ''
        this.addForm.path = ''
      }
    }
  },
  methods: {
    getMd5B(md5) {
      this.addForm.md5 = md5.md5
    },

    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },

    //打开对话框
    addDialog() {
      this.addDialogVisible = true
      this.getArticlesList()
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    },

    //获取文章列表
    getArticlesList () {
      getArticlesTitle(this.queryInfo).then(res => {
        this.articlesList = res.code === '0' ? res.data : []
      })
    },

    // 添加
    addBanner() {
      this.addForm.skipType = this.skipType
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        addBanner(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false;
          }
        })
      });
    },

  }
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 90%;
}
</style>
